<template lang="pug">
div
  h2.text-center {{errorTitle}}
  p.text-center {{errorMessage}}
  p &nbsp;
</template>

<script>
import errors from "../mixins/errors.js";
export default {
  name: "Error",
  mixins: [errors],
  props: {
    error: {
      type: Object,
      required: false,
      default: () => ({
        err: "ERROR",
        status: 404
      })
    }
  },
  computed: {
    errorMessage() {
      return this.getErrorMessage(this.error.status, this.error.err);
    },
    errorTitle() {
      return this.getErrorTitle(this.error.status, this.error.err);
    }
  }
};
</script>
